import React from 'react';
import { useNavigate } from 'react-router-dom';
import { object, string } from 'yup';

import { useAlerta, useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, Campo } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Departamento from 'Interface/Departamentos';
import { Erro } from 'Interface/Requisicao';
import { recuperarMensagemDeErro } from 'View/functions';
import { useAdicionarEpiMutation } from 'View/Service/Default/Epis';

const regras = object({
  nome: string().required('Obrigatório'),
  certificado_de_aprovacao: string().required('Obrigatório'),
});

const Adicionar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const alerta = useAlerta();
  const [adicionarEpi] = useAdicionarEpiMutation();

  const enviar = async (dados: Departamento): Promise<void> => {
    try {
      await adicionarEpi(dados).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao('/epis');
    } catch (error) {
      alerta({
        titulo: 'Erro ao adicionar',
        conteudo: recuperarMensagemDeErro((error as Erro).data.errors),
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Adicionando EPI"
        descricao="Preencha o formulário e clique em enviar para adicionar o EPI"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-4">
            <div className="bg-white shadow-sm rounded p-4">
              <Campo name="nome" rotulo="Nome" />
              <Campo name="certificado_de_aprovacao" rotulo="Certificado de aprovação" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink tema="light" to="/epis" className="ms-2">
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Adicionar;
